<template lang="pug">
.fondoModal
	div
		div
			.card.text-left
				.card-header
					span(v-if="datos.tipo === 'radio'")
						| {{ datos.linea.descripcion }}
					span(v-if="datos.tipo === 'otros'")
						| {{ datos.linea.concepto }}
					button.close(type='button' aria-label='Close' @click='cerrar')
						span(aria-hidden='true') &times;
				.row(style='padding: 0; margin: 0;')
					.col-xs-12.col-sm-6.col-md-6.col-lg-6.fondoGris
						h2.mt-3.text-info Total
						h1.text-info(style="font-weight:bold;") {{ importeTotal | currency('€')}}
						h2.mt-3.text-danger Pendiente
						h1.text-danger(style='font-weight:bold') {{ importePendiente | currency('€')}}
						hr
						.form-group
							label Día de cobro
							select.form-control(v-model="diaFactura", @change="cambiaDia()")
								option(:value="null") Selecciona
								option(v-for="(dia, index) in Array(31)", :key="index", :value="index + 1") {{(index + 1)}}
						p.text-right
							.btn-group
								button.btn.btn-danger(type='button' @click='reset()') Reset
								button.btn.btn-warning(type='button' @click='distribuir()') Distribuír
						//
							pre {{datos}}
					.col-xs-12.col-sm-6.col-md-6.col-lg-6
						.form-group
							label(for='calendario') Activa un año
							br
							.btn-group
								button(type='button' :disabled='!anoActivo(ano)' :class='claseAno(ano)' v-for='ano in listadoAnos' @click='toggleAno(ano)') {{ ano }}
						table.table.table-striped
							tbody
								tr(v-for='ano in anosActivos')
									td
										b {{ ano }}
										br
										button(type='button' :disabled='mesCerrado(ano, mes)' :class='getClaseMes(ano, mes)' @click='toggleMes(ano, mes)' v-for='mes in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]') {{ meses[mes] }}
						table.table.table-striped(v-if='datos.linea.pagos.length > 0')
							thead
								tr
									th Fecha
									th Importe
							tbody
								tr(v-for='(pago, index) in datos.linea.pagos')
									td {{pago.dia}} de {{meses[pago.mes]}} de {{ pago.ano }}
									td
										input.form-control.input-sm(type='number' :disabled='mesCerrado(pago.ano, pago.mes)' v-model.number='pago.importe')
									td
										button.btn.btn-xs.btn-danger(type='button' :disabled='mesCerrado(pago.ano, pago.mes)' @click='datos.linea.pagos.splice(index, 1)')
											span.fa.fa-trash

</template>

<script>
import API from '../../services/api'

export default {
	props: ['datos', 'cliente'],

	created: function () {
		// Debemos obtener el mes de cierre
		API.getCierre()
			.then(res => {
				this.cerrado.ano = parseInt(res.data.cierre.ano)
				this.cerrado.mes = parseInt(res.data.cierre.mes)
			})
			.catch(e => {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})

		if (this.cliente) {
			this.diaFactura = this.cliente.facturacion.dia_cobro + 0
		}
	},

	data: function () {
		return {
			meses: ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
			cerrado: {
				ano: new Date().getFullYear(),
				mes: new Date().getMonth()
			},
			diaFactura: null,
			error: null,
			anosActivados: []
		}
	},

	computed: {
		importeTotal () {
			if (typeof this.datos.contrato.dto_global === 'number' && this.datos.contrato.dto_global > 0) {
				return parseFloat(this.datos.linea.importe - (this.datos.linea.importe * this.datos.contrato.dto_global / 100))
			} else {
				return parseFloat(this.datos.linea.importe)
			}
		},

		importePendiente () {
			let pendiente = this.importeTotal + 0

			for (let i = 0; i < this.datos.linea.pagos.length; i++) {
				const pag = this.datos.linea.pagos[i]
				pendiente = pendiente - pag.importe
			}
			return pendiente
		},
		anosFacturados () {
			const anos = []

			for (let i = 0; i < this.datos.linea.pagos.length; i++) {
				const ano = parseInt(this.datos.linea.pagos[i].ano)

				if (anos.indexOf(ano) < 0) {
					anos.push(ano)
				}
			}

			return anos
		},
		listadoAnos () {
			let anos = []
			if (this.anosFacturados.length > 0) {
				anos = anos.concat(this.anosFacturados)
			}

			for (let i = new Date().getFullYear() - 1; i <= new Date().getFullYear() + 1; i++) {
				if (anos.indexOf(i) < 0) {
					anos.push(i)
				}
			}

			anos.sort()
			return anos
		},
		anosActivos () {
			let anos = []

			anos = anos.concat(this.anosActivados)

			for (let i = 0; i < this.datos.linea.pagos.length; i++) {
				const ano = parseInt(this.datos.linea.pagos[i].ano)

				if (anos.indexOf(ano) < 0) {
					anos.push(ano)
				}
			}

			return anos
		}
	},
	methods: {
		cambiaDia () {
			for (let i = this.datos.linea.pagos.length - 1; i >= 0; i--) {
				const l = this.datos.linea.pagos[i]
				if (!this.mesCerrado(l.ano, l.mes)) {
					this.datos.linea.pagos[i].dia = this.diaFactura + 0
				}
			}
		},
		roundNumber (num, scale) {
			return _.round(num, scale)
		},
		compruebaDia (fecha) {
			if (fecha.getFullYear() <= this.cerrado.ano && fecha.getMonth() + 1 <= this.cerrado.mes) {
				return false
			}

			return fecha.getDate() === 1
		},

		claseAno (ano) {
			if (this.anosActivados.indexOf(ano) < 0 && this.anosFacturados.indexOf(ano) < 0) {
				return 'btn btn-sm btn-default'
			}

			return 'btn btn-sm btn-primary'
		},

		toggleAno (ano) {
			const i = this.anosActivados.indexOf(ano)
			if (i < 0) {
				this.anosActivados.push(ano)
				this.anosActivados.sort()
				return
			}
			// Quitamos todos los importes de ese año
			let todos = true
			for (let i = this.datos.linea.pagos.length - 1; i >= 0; i--) {
				const p = this.datos.linea.pagos[i]

				if (p.ano === ano) {
					if (parseInt(p.ano) >= this.cerrado.ano && parseInt(p.mes) > this.cerrado.mes) {
						this.datos.linea.pagos.splice(i, 1)
					} else {
						todos = false
					}
				}
			}

			if (!todos) {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'No se puede quitar el año ya que hay meses activos'
				})
				return
			}

			this.anosActivados.splice(i, 1)
			this.anosActivados.sort()
		},

		anoActivo (ano) {
			return ano >= this.cerrado.ano
		},

		mesActivo (ano, mes) {
			if (ano > this.cerrado.ano) {
				return true
			} else if (ano < this.cerrado.ano) {
				return false
			} else if (mes > this.cerrado.mes) {
				return true
			} else {
				return false
			}
		},

		getClaseMes (ano, mes) {
			for (let i = 0; i < this.datos.linea.pagos.length; i++) {
				const p = this.datos.linea.pagos[i]

				if (parseInt(p.ano) === ano && parseInt(p.mes) === mes) {
					return 'btn btn-sm btn-primary'
				}
			}

			return 'btn btn-sm btn-default'
		},

		mesCerrado (ano, mes) {
			return (this.cerrado.ano >= parseInt(ano) && this.cerrado.mes >= parseInt(mes))
		},

		toggleMes (ano, mes) {
			if (this.mesCerrado(ano, mes)) {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Este mes ya está cerrado, no se puede quitar'
				})
				return
			}

			for (let i = 0; i < this.datos.linea.pagos.length; i++) {
				const p = this.datos.linea.pagos[i]

				if (parseInt(p.ano) === ano && parseInt(p.mes) === mes) {
					this.datos.linea.pagos.splice(i, 1)
					return
				}
			}

			if (!this.diaFactura) {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Debes seleccionar un día de cobro'
				})
				return
			}

			// Calculamos el día máximo
			const fechaMes = new Date(ano, mes - 1, 1, 0, 0, 0, 0)
			// Sumamos un mes y restamos un día
			fechaMes.setMonth(fechaMes.getMonth() + 1)
			fechaMes.setDate(fechaMes.getDate() - 1)
			const diaMax = fechaMes.getDate()
			const diaFactura = (this.diaFactura > diaMax) ? diaMax : this.diaFactura + 0

			this.datos.linea.pagos.push({
				ano: ano,
				mes: mes,
				dia: diaFactura,
				importe: 0
			})
		},

		reset () {
			for (let i = this.datos.linea.pagos.length - 1; i >= 0; i--) {
				const l = this.datos.linea.pagos[i]
				if (!this.mesCerrado(l.ano, l.mes)) {
					this.datos.linea.pagos.splice(i, 1)
				}
			}
		},

		distribuir () {
			if (this.datos.linea.pagos.length === 0) {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Debes agregar al menos un mes de facturación'
				})
				return
			}

			let pendiente = this.importeTotal + 0
			let mesesPte = 0

			for (let i = this.datos.linea.pagos.length - 1; i >= 0; i--) {
				const l = this.datos.linea.pagos[i]
				if (this.mesCerrado(l.ano, l.mes)) {
					pendiente = pendiente - l.importe
				} else {
					mesesPte++
				}
			}

			const media = this.roundNumber(pendiente / mesesPte, 2)

			for (let i = this.datos.linea.pagos.length - 1; i >= 0; i--) {
				const l = this.datos.linea.pagos[i]
				if (!this.mesCerrado(l.ano, l.mes)) {
					this.datos.linea.pagos[i].importe = media
				}
			}
		},

		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style lang="css">
	.fondoGris {
		background-color: #f9f9f9;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/listado/editar-facturacion.vue